export const eventPayload = {
  type: "event",
  agency: "",
  business: "",
  contact_details: {
    coordinator_name: "",
    phone: "",
    email: "",
    coordinator_name_2: "",
    phone_2: "",
    email_2: "",
    coordinator_name_3: "",
    phone_3: "",
    email_3: "",
  },
  quiz_id: '',
  is_premium: '',
  banner: "",
  logo: [],
  other_requirements: "",
  about_event: "",
  event_location: "",
  event_name: "",
  from_date: "",
  to_date: "",
  status: "",
  estimated_budget: "",
  workflow_id: {
    $oid: "",
  },
  current_step: "",
  employee: [],
  documents: [],
};

export const eventErrorPayload = {
  agency: "",
  business: "",
  coordinator_name: "",
  phone: "",
  email: "",
  coordinator_name_2: "",
  phone_2: "",
  email_2: "",
  coordinator_name_3: "",
  phone_3: "",
  email_3: "",
  other_requirements: "",
  about_event: "",
  event_location: "",
  event_name: "",
  from_date: "",
  to_date: "",
  estimated_budget: "",
  banner: "",
  logo: "",
  quiz_id: '',
  is_premium: '',
};

export const micePayload = {
  type: "mice",
  agency: "",
  business: "",
  contact_details: {
    coordinator_name: "",
    phone: "",
    email: "",
    coordinator_name_2: "",
    phone_2: "",
    email_2: "",
    coordinator_name_3: "",
    phone_3: "",
    email_3: "",
  },
  banner: "",
  quiz_id: '',
  is_premium: '',
  other_requirements: "",
  about_event: "",
  event_location: "",
  event_name: "",
  from_date: "",
  to_date: "",
  estimated_budget: "",
  workflow_id: {
    $oid: "",
  },
  current_step: "",
  status: "",
  employee: [],
  documents: [],
  additional_info: {
    conference_location: "",
    hotel_requirement: "",
    boarding_from: "",
    destination_to: "",
    service_required: "",
    number_of_persons: "",
    number_of_nights: "",
  },
};

export const miceErrorPayload = {
  agency: "",
  business: "",
  banner: "",
  quiz_id: '',
  is_premium: '',
  coordinator_name: "",
  coordinator_name_2: "",
  phone_2: "",
  email_2: "",
  coordinator_name_3: "",
  phone_3: "",
  email_3: "",
  phone: "",
  email: "",
  other_requirements: "",
  about_event: "",
  event_location: "",
  event_name: "",
  from_date: "",
  to_date: "",
  estimated_budget: "",
  conference_location: "",
  hotel_requirement: "",
  boarding_from: "",
  destination_to: "",
  service_required: "",
  number_of_persons: "",
  number_of_nights: "",
};
